import React from "react"
import {
  View,
  ValueInput,
  Window,
  Grid,
  Col,
  Text,
  Input,
  Button,
} from "react-ame-components"

export class ValueInputExample extends React.Component {
  state = {
    valueInteger: 10,
    valueDecimal: 125,
    valueCurrency: 250000,
  }
  render() {
    return (
      <Window>
        <View
          direction="column"
          align="center"
          justify="center"
          marginTop="big">
          <Grid>
            <Col columnSize={{ sm: 1, md: 3 }}></Col>
            <Col columnSize={{ sm: 10, md: 6 }}>
              <View
                backgroundColor="neutral-100"
                padding="big"
                borderRadius="small"
                shadow="level-2"
                direction="column"
                align="center">
                <Text
                  fontSize="large"
                  lineHeight="large"
                  fontWeight="bold">
                  Exemplo de um [color=secondary-300]ValueInput[/color]
                </Text>
                <Text>
                  Este componente serve para exibir uma entrada de valor
                  numérico. Veja abaixo:
                </Text>
                <View
                  paddingTop="small"
                  paddingBottom="medium"
                  justify="center"
                  direction="column"
                  borderBottomWidth="thin"
                  borderColor="neutral-300">
                  <Text>[b]valueType:[/b] "integer"(padrão)</Text>
                  <ValueInput
                    value={this.state.valueInteger}
                    onChange={v =>
                      this.setState({ valueInteger: v }, console.log(v))
                    }
                  />
                </View>
                <View
                  paddingTop="small"
                  paddingBottom="medium"
                  justify="center"
                  direction="column"
                  borderBottomWidth="thin"
                  borderColor="neutral-300">
                  <Text>[b]valueType:[/b] "integer"(flat)</Text>
                  <ValueInput
                    value={this.state.valueInteger}
                    onChange={v =>
                      this.setState({ valueInteger: v }, console.log(v))
                    }
                    flat
                  />
                </View>
                <View
                  paddingTop="big"
                  paddingBottom="medium"
                  justify="center"
                  direction="column"
                  borderBottomWidth="thin"
                  borderColor="neutral-300">
                  <Text>[b]valueType:[/b] "decimal"(padrão)</Text>
                  <ValueInput
                    value={this.state.valueDecimal}
                    onChange={v =>
                      this.setState({ valueDecimal: v }, console.log(v))
                    }
                    valueType="decimal"
                    decimals={1}
                    suffix="%"
                    disabled
                  />
                </View>
                <View
                  paddingTop="big"
                  paddingBottom="medium"
                  justify="center"
                  direction="column"
                  borderBottomWidth="thin"
                  borderColor="neutral-300">
                  <Text>[b]valueType:[/b] "decimal"(flat)</Text>
                  <ValueInput
                    value={this.state.valueDecimal}
                    onChange={v =>
                      this.setState({ valueDecimal: v }, console.log(v))
                    }
                    valueType="decimal"
                    decimals={1}
                    suffix="%"
                    disabled
                    flat
                  />
                </View>
                <View
                  paddingTop="big"
                  paddingBottom="medium"
                  justify="center"
                  direction="column"
                  borderBottomWidth="thin"
                  borderColor="neutral-300">
                  <Text>[b]valueType:[/b] "currency"(padrão)</Text>
                  <ValueInput
                    value={this.state.valueCurrency}
                    onChange={v =>
                      this.setState({ valueCurrency: v }, console.log(v))
                    }
                    valueType="currency"
                    prefix="R$"
                  />
                </View>
                <View
                  paddingTop="big"
                  paddingBottom="medium"
                  justify="center"
                  direction="column"
                  borderBottomWidth="thin"
                  borderColor="neutral-300">
                  <Text>[b]valueType:[/b] "currency"(flat)</Text>
                  <ValueInput
                    value={this.state.valueCurrency}
                    onChange={v =>
                      this.setState({ valueCurrency: v }, console.log(v))
                    }
                    valueType="currency"
                    prefix="R$"
                    flat
                    suffix="%"
                  />
                </View>
              </View>
            </Col>
          </Grid>
        </View>
      </Window>
    )
  }
}
